import { Loader2, ShieldCheck, ShieldX, ShieldAlert } from "lucide-react";
import { Button } from "../../../components/ui/button";
import { Input } from "../../../components/ui/input";
import { Label } from "../../../components/ui/label";

interface SiaeValidationSectionProps {
  matricula: string;
  onMatriculaChange: (value: string) => void;
  onValidate: () => void;
  loading: boolean;
  error: string | null;
  verifiedName: string | null;
  isValidated: boolean;
  onReset: () => void;
  fieldError?: string;
}

export function SiaeValidationSection({
  matricula,
  onMatriculaChange,
  onValidate,
  loading,
  error,
  verifiedName,
  isValidated,
  onReset,
  fieldError,
}: SiaeValidationSectionProps) {
  return (
    <div className="rounded-lg border border-indigo-100 bg-indigo-50/60 p-4 space-y-3">
      <div className="grid grid-cols-1 md:grid-cols-[1fr_auto] gap-3 items-end">
        <div className="space-y-2">
          <Label className="text-sm font-bold text-gray-700">Matricula UNACH *</Label>
          <Input
            value={matricula}
            onChange={(event) => onMatriculaChange(event.target.value.trim().toUpperCase().slice(0, 10))}
            placeholder="Ingresa tu matricula"
            inputMode="text"
            maxLength={10}
            readOnly={isValidated}
            className={isValidated ? "bg-gray-100 text-gray-500 border-gray-200 cursor-not-allowed" : ""}
          />
          {fieldError && <p className="text-red-500 text-sm">{fieldError}</p>}
        </div>

        <div className="flex gap-2">
          <Button
            type="button"
            onClick={onValidate}
            disabled={loading || matricula.trim().length < 6 || isValidated}
            className="bg-[#0f2744] hover:bg-[#142d4d] text-white min-w-[200px]"
          >
            {loading ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : null}
            {loading ? "Validando..." : "Validar matricula UNACH"}
          </Button>
          {isValidated && (
            <Button type="button" variant="outline" onClick={onReset}>
              Cambiar matricula
            </Button>
          )}
        </div>
      </div>

      {isValidated && verifiedName && (
        <div className="flex items-start gap-3 rounded-lg border border-emerald-200 bg-emerald-50 p-3 text-emerald-800">
          <ShieldCheck className="h-5 w-5 mt-0.5 shrink-0" />
          <div>
            <p className="font-semibold">Matricula valida</p>
            <p className="text-sm">{verifiedName}</p>
          </div>
        </div>
      )}

      {!isValidated && error && (
        <div className={`flex items-start gap-3 rounded-lg p-3 text-sm ${error.includes("Demasiados intentos") || error.includes("Servicio no disponible")
          ? "border border-amber-200 bg-amber-50 text-amber-800"
          : "border border-red-200 bg-red-50 text-red-700"
          }`}>
          {error.includes("Demasiados intentos") || error.includes("Servicio no disponible")
            ? <ShieldAlert className="h-5 w-5 mt-0.5 shrink-0" />
            : <ShieldX className="h-5 w-5 mt-0.5 shrink-0" />}
          <p>{error}</p>
        </div>
      )}
    </div>
  );
}
